import { ActionBase } from '../../../core/store/action/ActionBase';

export const GLOBAL_LOCK = '[Customer] Global Lock';

export class GlobalLockAction implements ActionBase {
  readonly identifier = new Date().getTime().toString();
  readonly type = GLOBAL_LOCK;
}



// WEBPACK FOOTER //
// ./src/app/customer/store/actions/GlobalLockAction.ts